
import { useContext } from "react";

import ServiceStackClientContext from '@/contexts/apis/ServiceStackClientContext';

const useServiceStackClient = () => {
    const client = useContext(ServiceStackClientContext);

    return client;
};

export default useServiceStackClient;